import { Grid, Link, TextField } from '@mui/material';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { LabeledInput } from 'app/components/RichList/items/CompanyItem/components/LabeledInput';
import { translations } from 'locales/i18n';
import { Company, ContactPerson } from 'types/AppTypes';

interface Props {
  contact: ContactPerson;
  editMode?: boolean;
  newCompany?: boolean;
}

const ContactInformation = ({ contact, editMode }: Props) => {
  const { t } = useTranslation();
  const formik = useFormikContext<Company>();

  const readOnlyFields = () => (
    <div className="section">
      <div className="section__header">{t(translations.common.contactPerson())}</div>
      <Grid container className="section__row">
        <Grid item xs>
          <LabeledInput displayAlways label={t(translations.common.companyName())}>
            {contact.firstName} {contact.lastName}
          </LabeledInput>
        </Grid>
        <Grid item xs>
          <LabeledInput displayAlways label={t(translations.common.phone())}>
            {contact.phone}
          </LabeledInput>
        </Grid>
      </Grid>
      <Grid container className="section__row">
        <Grid item xs>
          <LabeledInput displayAlways label={t(translations.common.email_login())}>
            <Link href={`mailto:${contact.email}`}>{contact.email}</Link>
          </LabeledInput>
        </Grid>
        <Grid item xs>
          <LabeledInput displayAlways label={t(translations.common.position())}>
            {contact.position}
          </LabeledInput>
        </Grid>
      </Grid>
    </div>
  );

  if (!editMode) {
    return readOnlyFields();
  }

  const { errors } = formik;

  return (
    <div className="section">
      <div className="section__header">{t(translations.common.contactPerson())}</div>
      <Grid container className="section__row">
        <Grid item xs>
          <Field
            as={TextField}
            name="mainContact.firstName"
            error={errors.mainContact?.firstName}
            helperText={errors.mainContact?.firstName}
            required
            label={t(translations.common.firstName())}
          />
        </Grid>
        <Grid item xs>
          <Field
            as={TextField}
            name="mainContact.lastName"
            error={errors.mainContact?.lastName}
            helperText={errors.mainContact?.lastName}
            required
            label={t(translations.common.lastName())}
          />
        </Grid>
      </Grid>
      <Grid container className="section__row">
        <Grid item xs>
          <Field
            as={TextField}
            name="mainContact.phone"
            error={errors.mainContact?.phone}
            helperText={errors.mainContact?.phone}
            required
            label={t(translations.common.phone())}
          />
        </Grid>
        <Grid item xs>
          <Field
            as={TextField}
            name="mainContact.position"
            error={errors.mainContact?.position}
            helperText={errors.mainContact?.position}
            required
            label={t(translations.common.position())}
          />
        </Grid>
      </Grid>
      <Grid container className="section__row__single">
        <Grid item xs>
          <Field
            as={TextField}
            name="mainContact.email"
            error={errors.mainContact?.email}
            helperText={errors.mainContact?.email}
            required
            label={t(translations.common.email_login())}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default ContactInformation;
